import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoNyn: CultureInfo = {
  name: 'nyn',
  displayName: 'Runyankore',
  iso3LanguageCode: 'nyn',
  iso2LanguageCode: 'nyn',
  ietfLanguageTag: 'nyn',
  parent: null
};
